import React, { cloneElement, isValidElement, useState } from "react";
import * as PropTypes from "prop-types";
import AbsoluteValuesSwitch from "./AbsoluteValuesSwitch";
import DataViewerFrame from "./DataViewerFrame";

const AbsoluteChartToggleFrame = ({ children, initialAbsolute, ...rest }) => {
  const [absolute, setAbsolute] = useState(initialAbsolute);

  // noinspection JSUnresolvedFunction
  return (
    <DataViewerFrame
      {...rest}
      absoluteToggle={
        <AbsoluteValuesSwitch
          checked={absolute}
          onToggle={() => {
            setAbsolute(!absolute);
          }}
        />
      }
    >
      {isValidElement(children)
        ? cloneElement(children, {
            absolute
          })
        : null}
    </DataViewerFrame>
  );
};

AbsoluteChartToggleFrame.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dataViewerId: PropTypes.string,
  reference: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  contentWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.element.isRequired,
  filters: PropTypes.arrayOf(PropTypes.element),
  initialAbsolute: PropTypes.bool,
  chartRef: PropTypes.object,
  chartSettings: PropTypes.object,
  downloadAbsoluteValues: PropTypes.bool
};

AbsoluteChartToggleFrame.defaultProps = {
  initialAbsolute: true
};

export default AbsoluteChartToggleFrame;
